import React, { Component, useState, useEffect } from "react";

import { BrowserRouter as Router, Route, Switch, useLocation, Redirect } from "react-router-dom";
import "./App.css";
import { getFirestore, doc, updateDoc } from "firebase/firestore";

import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import CSAE from "./pages/CSAE";
import firebase from "./firebase";




// import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import jwtDecode from "jwt-decode";
// Firebase Auth State Monitoring
import AuthNotification from "./components/AuthNotification";
import { app } from "./util/firebase"; // Import Firebase app instance
// Test utilities for development
import "./utils/authTestUtils";
// Redux
import { Provider, connect } from "react-redux";
import store from "./redux/store";
import { SET_AUTHENTICATED } from "./redux/types";
import { logoutUser, getUserData, connectToLichess } from "./redux/actions/userActions";
// Components
import Navbar from "./components/layout/Navbar";
import themeObject from "./util/theme";
import AuthRoute from "./util/AuthRoute";
import PremiumRoute from "./util/PremiumRoute";
import AdminRoute from "./util/AdminRoute";
import { MobileContext } from "./context/MobileContext";

// Pages
import { home, login, signup, user, ViewGame, AddGame, Explore, resetPassword as ResetPassword } from "./pages";
import { getLichessUser } from "./util/api/lichess";
import "./util/firebase";

import axios from "axios";

import ViewGame2 from "./pages/2ViewGame";
import AddGame3 from "./pages/Archive/3AddGame";
import AddGame2 from "./pages/2AddGame";
import MobileAddGame from "./mobile/pages/2AddGame";
import MobileFENBuilder from "./mobile/pages/FENBuilder";
import MobileInteractions from "./mobile/pages/Interactions";
import MobileProfile from "./mobile/pages/Profile";
import MobileLogin from "./mobile/pages/LoginMobile";
import MobileSignup from "./mobile/pages/SignupMobile";
import MobileFAQ from "./mobile/pages/FAQMobile";
import MobileSettings from "./mobile/pages/MobileSettings";
import MobileContact from "./mobile/pages/ContactMobile";
import MobileAbout from "./mobile/pages/AboutMobile";
import MobileTerms from "./mobile/pages/TermsMobile";
import MobilePrivacy from "./mobile/pages/PrivacyMobile";
import MobileForgotPassword from "./mobile/pages/ForgotPasswordMobile";
import MobilePortal from "./mobile/pages/Portal";
import ViewGameMobileRoute from "./mobile/components/ViewGameRoute";
import MobileBookmarks from "./mobile/pages/BookmarksMobile";
import SearchMobile from "./mobile/pages/SearchMobile";
import AddGameRoute from "./components/WorkingChessLogic/AddGameRoute";
import ViewGameRoute from "./components/WorkingChessLogic/ViewGameRoute";

import ChesssLogo from "./images/chessslogo.png";
import mansalva from "./images/Mansalva/Mansalva-Regular.ttf";
import { colors, Portal } from "@material-ui/core";
import { useContext } from "react";
import Sidebar from "./pages/Sidebar";
import BottomNavigation from "./mobile/components/BottomNavigation";
import { ChessSocialProvider } from "./util/ChessSocialContext";
import { PremiumProvider, usePremium } from "./util/PremiumFilter";
import { RecordModeContext } from "./mobile/pages/ViewGameMobile";
import interaction from "./pages/interaction";
import portal from "./pages/portal";
// import profile from "./pages/profile";
import profile from "./pages/profile";
import bookmark from "./pages/bookmark";
import play from "./pages/play";
import PlayChess from "./pages/Archive/PlayChess"
import game from "./pages/game";
import friends from "./pages/Components/friends";
import Lila from "./pages/Archive/Lila";
import Premium from "./pages/Premium";
import Settings from "./pages/Settings";
import Landing from "./pages/Landing";
import PremiumPortal from "./pages/PremiumPortal";
import LiChess from "./pages/Archive/LilaFAQ";
import OauthCallback from './pages/OauthCallback';
import AdminDashboard from "./pages/AdminDashboard";
import ChessAnalysisTest from "./pages/Archive/ChessAnalysisTest";
import More from "./pages/More";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { isNativeApp } from "./util/platformDetection";
import NativeAppLanding from "./mobile/pages/NativeAppLanding";
import MobileBrowserLanding from "./mobile/pages/MobileBrowserLanding";
import NativeAppHeader from "./mobile/components/NativeAppHeader";



const auth = getAuth();
onAuthStateChanged(auth, (user) => {
  if (user) {
    // console.log(user.uid); // Safe access
  } else {
    // console.log("No user signed in");
  }
});

const theme = createTheme(themeObject);

axios.defaults.baseURL = 
    process.env.REACT_APP_API_BASE_URL || "https://api-v7poaqj4ga-uc.a.run.app";

// Token and auth state will now be handled by Firebase onAuthStateChanged listener
// const token = localStorage.FBIdToken;
const lichessToken = localStorage.LichessIdToken;

// Lichess token handling (if it exists)
if (lichessToken) {
    getLichessUser().then(() => {
        store.dispatch(connectToLichess(lichessToken));
    }).catch(error => {
        localStorage.removeItem('LichessIdToken');
        // console.error("Error getting lichess user:", error);
        // console.error("token may no longer be valid");
    });
}




// Create a wrapper component for PremiumRoute that uses the usePremium hook
const PremiumRouteContainer = ({ component, ...rest }) => {
    const { isPremiumUser, premiumTier, PREMIUM_TIERS } = usePremium();
    const { credentials, loading } = store.getState().user;
    
    // Check if credentials are properly loaded (not empty)
    const dataIsLoaded = credentials && Object.keys(credentials).length > 0;
    
    // Consider any premium tier above NONE as premium for routing purposes
    const hasPremiumAccess = premiumTier > PREMIUM_TIERS.NONE;
    
    // Debug log to see what values we're getting
    // console.log('Premium Route Check:', { 
    //     premiumTier, 
    //     PREMIUM_TIERS, 
    //     hasPremiumAccess,
    //     isPremiumUser,
    //     dataIsLoaded,
    //     loading
    // });
    
    // Only redirect if data is loaded AND user doesn't have premium
    // This prevents premature routing when we don't have user data yet
    const shouldRedirect = dataIsLoaded && !hasPremiumAccess;
    
    // If shouldRedirect is true, we'll use PremiumRoute to redirect
    // Otherwise we'll render the component directly
    return shouldRedirect 
        ? <PremiumRoute component={component} isPremiumUser={false} {...rest} />
        : <Route {...rest} component={component} />;
};






// Create a MobileRedirect component near the PremiumRouteContainer
const MobileRedirect = () => {
  const [isRedirecting, setIsRedirecting] = useState(true);
  
  useEffect(() => {
    // Display message for a brief period before redirecting
    setIsRedirecting(true);
    const timeout = setTimeout(() => {
      setIsRedirecting(false);
    }, 2000);
    
    return () => clearTimeout(timeout);
  }, []);
  
  if (!isRedirecting) {
    return <Redirect to="/landing" />;
  }
  
  return (
    <div style={{ 
      padding: '20px', 
      textAlign: 'center', 
      color: 'gold',
      backgroundColor: 'black',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <img src={ChesssLogo} alt="Chess Republic Logo" style={{ width: '250px', marginBottom: '20px' }} />
      <h1>Mobile Version Coming Soon!</h1>
      <p>Full functionality is currently available on desktop at ChessThread.com.</p>
    </div>
  );
};

// Enhanced platform detection function
const getPlatformType = () => {
    const ua = navigator.userAgent;
    const isNarrowScreen = window.innerWidth <= 1000;
    
    // Native app detection (highest priority)
    if (isNativeApp()) {
        return 'native-app';
    }
    
    // Desktop browser detection (Windows, Mac, Linux)
    if (/Windows NT|Macintosh|Linux.*x86_64|Win64|Intel Mac/i.test(ua)) {
        return isNarrowScreen ? 'desktop-mobile-view' : 'desktop';
    }
    
    // Real mobile device browser
    if (/iPhone|iPad|iPod|Android|Mobile|Tablet/i.test(ua)) {
        return 'real-mobile-browser';
    }
    
    // Default to desktop treatment
    return 'desktop';
};

// Inner App component that can use Redux connect
function AppContent({ isAuthenticated }) {
    const [smallContainerTab, setSmallContainerTab] = useState('tab1');
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
    // Record Mode state for controlling bottom navigation visibility
    const [isRecordMode, setIsRecordMode] = useState(false);
    
    // Auth notification states
    const [showAuthNotification, setShowAuthNotification] = useState(false);
    const [userWasAuthenticated, setUserWasAuthenticated] = useState(false);
    
    // Auth loading state
    const [authLoading, setAuthLoading] = useState(true);

    const db = getFirestore();


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1000);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Firebase Auth State Listener
    useEffect(() => {
        const auth = getAuth(app);
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            // console.log('Auth state changed:', { user: user ? user.uid : null, userWasAuthenticated });
            
            if (user) {
                // User is signed in
                try {
                    // Get fresh ID token and set authorization header
                    const idToken = await user.getIdToken(true);
                    const FBIdToken = `Bearer ${idToken}`;
                    localStorage.setItem('FBIdToken', FBIdToken);
                    axios.defaults.headers.common['Authorization'] = FBIdToken;
                    
                    // Dispatch authentication actions
                    store.dispatch({ type: SET_AUTHENTICATED });
                    store.dispatch(getUserData());
                    
                    setUserWasAuthenticated(true);
                    setShowAuthNotification(false);
                } catch (error) {
                    // console.error('Error setting up authentication:', error);
                    // If token fails, treat as unauthenticated
                    store.dispatch(logoutUser());
                    setUserWasAuthenticated(false);
                }
            } else {
                // User is signed out
                if (userWasAuthenticated) {
                    // Only show notification if user was previously authenticated
                    // This prevents showing notification on initial page load
                    // console.log('User was authenticated but now signed out - showing notification');
                    setShowAuthNotification(true);
                }
                setUserWasAuthenticated(false);
                store.dispatch(logoutUser());
            }
            
            // Auth state is now determined
            setAuthLoading(false);
        });

        return () => unsubscribe();
    }, []); // Empty dependency array - run only once on mount

    // Check if current path is login, signup, or reset-password
    const isAuthPage = window.location.pathname === '/login' ||
        window.location.pathname === '/signup' ||
        window.location.pathname === '/reset-password';
        
    // Define mobile-allowed routes
    const mobileAllowedRoutes = [
      '/landing', 
      '/Landing',
      '/',
      '/terms',
      '/privacy',
      '/analysis',
      '/mobile/fen-builder',
      '/login',
      '/signup',
      '/reset-password',
      '/interaction',
      '/portal',
      '/profile',
      '/more',
      '/settings',
      '/mobile-settings',
      '/faq',
      '/contact',
      '/about',
      '/games'
    ];
    
    // Check if current path is allowed on mobile
    const isPathAllowedOnMobile = mobileAllowedRoutes.some(
      route => window.location.pathname.toLowerCase().startsWith(route.toLowerCase())
    );
    
    // Should redirect to landing if on mobile and not on an allowed path
    const shouldRedirectOnMobile = isMobile && !isPathAllowedOnMobile;

    // Auth notification handlers
    const handleRefreshPage = () => {
        window.location.reload();
    };

    const handleDismissNotification = () => {
        setShowAuthNotification(false);
    };

    // Show loading screen while auth is initializing
    if (authLoading) {
        return (
            <MuiThemeProvider theme={theme}>
                <div style={{ 
                    padding: '20px', 
                    textAlign: 'center', 
                    color: 'gold',
                    backgroundColor: '#121212',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <style>
                        {`
                          @font-face {
                            font-family: 'Mansalva';
                            src: url(${mansalva}) format('truetype');
                            font-weight: normal;
                            font-style: normal;
                          }
                          
                          @keyframes fadeInSmooth {
                            from { opacity: 0; transform: translateY(10px); }
                            to { opacity: 1; transform: translateY(0); }
                          }
                          
                          .loading-fade-in {
                            opacity: 0;
                            animation: fadeInSmooth 0.5s ease-out forwards;
                          }
                        `}
                    </style>
                    <img src={ChesssLogo} alt="Chess Republic Logo" className="loading-fade-in" style={{ width: '150px', marginBottom: '20px' }} />
                    <div className="loading-fade-in" style={{ fontSize: '36px', fontFamily: 'Mansalva, cursive', animationDelay: '0.2s' }}>Loading...</div>
                </div>
            </MuiThemeProvider>
        );
    }

    return (
        <MuiThemeProvider theme={theme}>
            <Router forceRefresh={true}>
                <ChessSocialProvider>
                    <PremiumProvider>
                        <RecordModeContext.Provider value={{ isRecordMode, setIsRecordMode }}>
                            <MobileContext.Provider value={isMobile}>
                                {/* Auth notification overlay - appears above all content */}
                                <AuthNotification 
                                    show={showAuthNotification}
                                    onRefresh={handleRefreshPage}
                                    onDismiss={handleDismissNotification}
                                />
                                {shouldRedirectOnMobile ? (
                                    // For mobile devices trying to access non-allowed pages
                                    <MobileRedirect />
                                ) : isAuthPage ? (
                                    // Render login/signup pages without additional containers
                                        <Switch>
                                            <AuthRoute exact path="/login" component={isMobile ? MobileLogin : login} />
                                            <AuthRoute exact path="/signup" component={isMobile ? MobileSignup : signup} />
                                            <AuthRoute exact path="/reset-password" component={isMobile ? MobileForgotPassword : ResetPassword} />
                                            <Redirect to="/login" />
                                        </Switch>
                                ) : (
                                    // For all other pages, use the container structure
                                    <div className="app-container">
                                        {/* Don't show sidebar on Landing page and LiChessFAQ regardless of authentication */}
                                        {isAuthenticated &&
                                            !window.location.pathname.includes('Landing') &&
                                            !window.location.pathname.includes('landing') &&
                                            !window.location.pathname.includes('LiChessFAQ') &&
                                            !window.location.pathname.includes('Terms') &&
                                            !window.location.pathname.includes('Privacy') ? (
                                            <>
                                                {/* Show sidebar on desktop, bottom nav on mobile */}
                                                {!isMobile && (
                                                    <div className="main-column" style={{}} >
                                                        <Sidebar></Sidebar>
                                                    </div>
                                                )}
                                                <div className={isMobile ? "mobile-main-container" : "main-container"} style={isMobile ? { paddingBottom: '70px' } : {}}>
                                                    <Switch>
                                                        <Route exact path="/Landing" component={Landing} />
                                                        <Route exact path="/game" component={game} />
                                                        <Route exact path="/games/:gameId" component={isMobile ? ViewGameMobileRoute : ViewGameRoute} />
                                                        <Route exact path="/Analysis" component={isMobile ? MobileAddGame : AddGameRoute} />
                                                        <Route exact path="/mobile/fen-builder" component={isMobile ? MobileFENBuilder : AddGameRoute} />
                                                        <Route exact path="/mobile/terms" component={MobileTerms} />
                                                        <Route exact path="/mobile/privacy" component={MobilePrivacy} />
                                                        <Route exact path="/Terms" component={Terms} />
                                                        <Route exact path="/Privacy" component={Privacy} />
                                                        <Route exact path="/Support" component={Support} />
                                                        <Route exact path="/CSAE" component={CSAE} />
                                                        <Route exact path="/" component={isMobile ? MobilePortal : portal} />
                                                        {/* <Route exact path="/Explore" component={Explore} /> */}
                                                        <Route exact path="/Play" component={play} />
                                                        <Route exact path="/Play/:challengeUser" component={play} />
                                                        <Route exact path="/PlayChess" component={PlayChess} />
                                                        <Route exact path="/Lila" component={Lila} />
                                                        <Route exact path="/Bookmark" component={bookmark} />
                                                        <Route exact path="/bookmarks" component={isMobile ? MobileBookmarks : bookmark} />
                                                        <Route exact path="/profile" component={isMobile ? MobileProfile : profile} />
                                                        <Route exact path="/profile/:handle" component={isMobile ? MobileProfile : profile} />
                                                        <Route exact path="/portal" component={isMobile ? MobilePortal : portal} />
                                                        <Route exact path="/LiChessFAQ" component={LiChess} />
                                                        <AdminRoute exact path="/admin" component={AdminDashboard} />
                                                        {/* <PremiumRouteContainer exact path="/Premium-Portal" component={PremiumPortal} /> */}
                                                        {/* <Route exact path="/Premium" component={Premium} /> */}
                                                        <Route exact path="/friends" component={friends} />
                                                        <Route exact path="/interaction" component={isMobile ? MobileInteractions : interaction} />
                                                        <Route exact path="/Settings" component={isMobile ? MobileSettings : Settings} />
                                                        <Route exact path="/mobile-settings" component={MobileSettings} />
                                                        <Route exact path="/faq" component={isMobile ? MobileFAQ : Settings} />
                                                        <Route exact path="/contact" component={isMobile ? MobileContact : Settings} />
                                                        <Route exact path="/about" component={isMobile ? MobileAbout : Settings} />
                                                        <Route exact path="/search" component={SearchMobile} />
                                                        <Route exact path="/more" component={More} />
                                                        <Route exact path="/users/:handle" component={user} />
                                                        <Route exact path="/users/:handle/scream/:screamId" component={user} />
                                                        <Route exact path="/oauth/callback" component={OauthCallback} />
                                                        <Route exact path="/chess-analysis-test" component={ChessAnalysisTest} />

                                                        {/* <Route exact path="/games2/:gameId" component={ViewGameRoute} /> */}
                                                        {/* <Route exact path="/aAddGame" component={AddGame3} />
                                                        <Route exact path="/AddGame2" component={AddGameRoute} /> */}
                                                    </Switch>
                                                </div>
                                                {/* Show header on native app only */}
                                                {isNativeApp() && <NativeAppHeader />}
                                                {/* Show bottom navigation on mobile (but not in Record mode) */}
                                                {isMobile && !isRecordMode && <BottomNavigation />}
                                            </>
                                        ) : (
                                            <>
                                                {/* Only render sidebar on game pages and not Landing or LiChessFAQ */}
                                                {(window.location.pathname.startsWith('/games/') ||
                                                    window.location.pathname === '/Premium') &&
                                                    !window.location.pathname.startsWith('/landing') &&
                                                    !window.location.pathname.startsWith('/Landing') &&
                                                    window.location.pathname !== '/LiChessFAQ' && (
                                                        <div className="main-column" style={{}}>
                                                            <Sidebar></Sidebar>
                                                        </div>
                                                    )}

                                                <div className={(window.location.pathname.startsWith('/games/') ||
                                                    window.location.pathname === '/Premium') &&
                                                    !window.location.pathname.startsWith('/landing') &&
                                                    !window.location.pathname.startsWith('/Landing')
                                                    ? "main-container" : "app-container"}>
                                                    <Switch>
                                                        <Route exact path="/Landing" component={Landing} />
                                                        <Route exact path="/" component={() => {
                                                            const platformType = getPlatformType();
                                                            
                                                            switch(platformType) {
                                                                case 'desktop':
                                                                    return <Landing />;
                                                                case 'desktop-mobile-view':
                                                                    return <MobilePortal />;
                                                                case 'native-app':
                                                                    return <NativeAppLanding />;
                                                                case 'real-mobile-browser':
                                                                    return <MobileBrowserLanding />;
                                                                default:
                                                                    return <Landing />;
                                                            }
                                                        }} />
                                                        <Route exact path="/games/:gameId" component={isMobile ? ViewGameMobileRoute : ViewGameRoute} />
                                                        <Route exact path="/mobile/terms" component={MobileTerms} />
                                                        <Route exact path="/mobile/privacy" component={MobilePrivacy} />
                                                        <Route exact path="/Terms" component={Terms} />
                                                        <Route exact path="/Privacy" component={Privacy} />
                                                        <Route exact path="/Support" component={Support} />
                                                        <Route exact path="/CSAE" component={CSAE} />
                                                        <Route exact path="/LiChessFAQ" component={LiChess} />
                                                        <Redirect to={isNativeApp() ? "/" : "/landing"} />
                                                    </Switch>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </MobileContext.Provider>
                        </RecordModeContext.Provider>
                    </PremiumProvider>
                </ChessSocialProvider>
                </Router>
        </MuiThemeProvider>
    );
}

// Connect AppContent to Redux
const mapStateToProps = (state) => ({
    isAuthenticated: state.user.authenticated
});

const ConnectedAppContent = connect(mapStateToProps)(AppContent);

// Main App component that provides Redux store
function App() {
    return (
        <Provider store={store}>
            <ConnectedAppContent />
        </Provider>
    );
}

export default App;


